<div class=" container-scroller">
    <!-- <nav class="navbar default-layout-navbar p-0 fixed-top d-flex flex-row" style="width: 260px;height: 140px;">
        <div class="text-center navbar-brand-wrapper d-flex align-items-center justify-content-center"
            style="border-right: 1px solid #9c9fa6;border-bottom: 1px solid #9c9fa6;">
            <img src="../../assets/POA_IconLogo.png" style="height:130px; " />
            <img src="../../assets/POA_TextLogo.png" style="padding-top: 65px;" />
        </div>

    </nav> -->

    <div class="container-fluid page-body-wrapper" style="padding-left: 260px; top: 50px; position: absolute; z-index: -1;">
        <div class="main-panel">
            <div class="content-wrapper" style="padding: 1.5rem .8rem .5rem 2rem;">
                <div class="page-header">
                    <h2 class="page-title text-primary">EMPLOYEE</h2>
                </div>

                <div class="form" [hidden]="isShownWrite">
                    <div class="row" style="padding-bottom: 20px;">
                        <div class="col-lg-4" style="text-align: left;">
                            <label>Employee Number</label><span style="color: red;">*</span><br />
                            <input type="text" id="NotifyNum" [(ngModel)]="EmployeeNum" class="txt-input" />
                        </div>

                    </div>

                    <div class="row" style="width:100%;padding-left: 15px; ">
                        <div class="col-lg-10" style="border: ridge;padding-bottom: 2em;">
                            <div class="col-lg-12">
                                <div class="row" style="padding-top:1em;">
                                    <div class="col-lg-4">
                                        <label>Employee Name</label><span style="color: red;">*</span><br />
                                        <input type="text" class="txt-input" [(ngModel)]="EmployeeName" />
                                    </div>
                                    <div class="col-lg-4">
                                        <label>Role</label><span style="color: red;">*</span><br />
                                        <select class="form-control" [(ngModel)]="RoleId"
                                            style="border: 1px solid #9c9fa6 !important;border-radius: 5px !important;outline: none !important ;">
                                            <option value="0" disabled>Select</option>
                                            <option *ngFor="let rls of Roles" value={{rls.roleId}}>{{rls.roleName}}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                <div class="row" style="padding-top:1em;">
                                <div class="col-lg-5">
                                    <label>Email Id</label><span style="color: red;">*</span><br />
                                    <input type="text" class="txt-input" [(ngModel)]="EmployeeEmail" />
                                </div>
                                <div class="col-lg-4" style="padding-right: 1px;">
                                    <label>Password</label><span style="color: red;">*</span><br />
                                    <input type="password" class="txt-input" [(ngModel)]="EmployeePass" id="txtpassword" style="width: 82%;" />
                                    <!-- <img class="fa fa-eye" id="pass-signstatus" style="padding-top: 35px;" (click)="viewPassword()" /> -->
                                    <i id="pass-signstatus" class="fa fa-eye" aria-hidden="true" (click)="viewPassword()"></i> 
                                </div>
                                <div class="col-lg-3" [hidden]="isShownActiveEmp" style="padding-top: 40px;">
                                    <input type="checkbox" [(ngModel)]="StatusEmp"> Set As Active
                                </div>
                            </div>
                            </div>
                        </div>

                    </div>

                    <div class="row" style="padding-top: 10px;">
                        <div class="col-lg-5">
                            <label>Description</label> <br />
                            <textarea cols="40" rows="3" id="description" [(ngModel)]="description"
                                class="txt-input"></textarea>
                        </div>
                        <div class="col-lg-2" style="padding-top:60px;" [hidden]="isShownActive">
                            <input type="checkbox" [(ngModel)]="Status"> Set As Inactive
                        </div>
                        <div class="col-lg-4" style="padding-top: 50px;">
                            <button class="bttn-save " [hidden]="isShownSaveBtn" (click)="InsertEmployee()">SAVE</button>
                            &nbsp;&nbsp;
                            <button class="bttn-Update" [hidden]="isShownUpdateBtn" (click)="UpdateEmployee()">Update</button>&nbsp;&nbsp;
                            <button class="bttn-clear " (click)="ClearEmployee()">CLEAR</button>
                        </div>
                    </div>
    
                    <div class="col-md-12" style="padding-bottom: 25px; text-align: Left;">
                        <span style="color: red;">{{ErrorMsg}}</span>
                        <span style="color: green;">{{SuccessMsg}}</span>
                    </div>
    
                </div>

                
            </div>


            <div class="content-wrapper">
                <div class="row">
                    <div class="col-lg-12 grid-margin">
                        <div class="card">
                            <div class="card-body" style="width:fit-content;">
                                <div class="row">
                                    <div class="col-12 grid-margin">
                                        <div class="card">
                                            <div class="card-body" style="padding: 0;">
                                                <div class="col-lg-12 form-inline"
                                                    style="border: 1px solid #9c9fa6; padding: 5px;background-color: #f0f0f1">
                                                    <div class="col-lg-4"></div>
                                                    <div class="col-lg-8">
                                                        <div class="form-group">
                                                            <div class="input-group">
                                                                <input type="text" placeholder="Search"
                                                                    [(ngModel)]="searchText"
                                                                    (keyup)="applyFilter($event.target.value)"
                                                                    class="txt-Search"> <i class="fa fa-search fa-2x"
                                                                    style="color:#38C3FA;position: absolute;    left: 72%; top: 3px;"></i>

                                                            </div>
                                                            <button type="button" class="btn btn-sm ">
                                                                <img src="../../assets/ExportPDF.png" />
                                                            </button>
                                                            <button type="button" class="btn  btn-sm" (click)="exportexcel()">
                                                                <img src="../../assets/ExportExcel.png"
                                                                    style="cursor: pointer;" />
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>


                                                <div class="col-sm-12 mat-elevation-z8"
                                                    style="box-shadow: unset;padding: 0px ;" #TABLE>
                                                    <table mat-table [dataSource]="dataSource" #table
                                                        style="width: 100%;" matSortmat-table [dataSource]="dataSource"
                                                        #table style="width: 100%;" matSort>
                                                        <ng-container matColumnDef="sno">
                                                            <th mat-header-cell *matHeaderCellDef
                                                                style="color: black !important;background-color: white">
                                                                S.NO </th>
                                                            <td mat-cell *matCellDef="let item; let j = index">
                                                                {{(j +1)  + (myPaginator.pageIndex * myPaginator.pageSize) }}
                                                            </td>
                                                        </ng-container>
                                                        <ng-container matColumnDef="employeeNo">
                                                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                                style="color: black !important;background-color: white">
                                                                Employee Number</th>
                                                            <td mat-cell *matCellDef="let element"
                                                                (click)="EditEmployee(element)"
                                                                style="cursor: pointer;">
                                                                {{element.employeeNo}}
                                                            </td>
                                                        </ng-container>
                                                        <ng-container matColumnDef="employeeName">
                                                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                                style="color: black !important;background-color: white">
                                                                Employee Name</th>
                                                            <td mat-cell *matCellDef="let element"
                                                                (click)="EditEmployee(element)"
                                                                style="cursor: pointer;">
                                                                {{element.employeeName}}
                                                            </td>
                                                        </ng-container>
                                                        <ng-container matColumnDef="roleName">
                                                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                                style="color: black !important;background-color: white">
                                                                Role</th>
                                                            <td mat-cell *matCellDef="let element"
                                                                (click)="EditEmployee(element)"
                                                                style="cursor: pointer;">
                                                                {{element.roleName}}
                                                            </td>
                                                        </ng-container>
                                                        <ng-container matColumnDef="status">
                                                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                                style="color: black !important;background-color: white">
                                                                Status</th>
                                                            <td mat-cell *matCellDef="let element"
                                                                (click)="EditEmployee(element)"
                                                                style="cursor: pointer;">
                                                                {{element.status}}
                                                            </td>
                                                        </ng-container>
                                                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                                        <tr mat-row *matRowDef="let row; columns: displayedColumns;">
                                                        </tr>
                                                    </table>
                                                    <mat-paginator #myPaginator [pageSizeOptions]="[5, 10,15, 20,30,40]"
                                                        showFirstLastButtons></mat-paginator>
                                                </div>


                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-4"></div>
                                    <div class="col-lg-4"></div>
                                    <div class="col-lg-4">

                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- partial:../../partials/_footer.html -->
            <footer class="footer">
                <div class="d-sm-flex justify-content-center">
                    <span class="d-block d-sm-inline-block">
                        © 2020 All Rights Reserved
                        <a href="https://www.sysmedacmicrosoft.com/#!/" target="_blank" style="color:black;">
                            <img src="../../assets/Logo-V3.png" width="70" />
                        </a>

                    </span>

                </div>
            </footer>
            <!-- partial -->
        </div>
    </div>
</div>